// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"377":"play","438":"online","552":"rules"}[chunkId] || chunkId) + "." + {"32":"9f152d5c","225":"a2405dbe","377":"cdef8d01","438":"b2a94934","507":"12b2f4bd","552":"a72e11a9"}[chunkId] + ".js";
};